import React, { FC, useCallback, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Step } from '../../types';

import { StepperContext } from 'app/design-system/components/Stepper/context';
import { Trans } from 'app/lang';
import useAdultAge from 'app/lib/region/useAdultAge';
import { OfferModal } from 'app/modules/Signing/components/OfferModal';

import dictionary from './AdultAge.dictionary.json';

import styles from './AdultAge.module.scss';

export const AdultAge: FC = () => {
  const [modalVisibility, setModalVisibility] = useState(false);
  const adultAge = useAdultAge();
  const history = useHistory();

  const onModalOpen = useCallback(() => {
    setModalVisibility(true);
  }, []);

  const onModalClose = useCallback(() => {
    history.goBack();
    setModalVisibility(false);
  }, []);

  const { activeStep } = useContext(StepperContext);

  if (activeStep !== Step.INITIAL){
    return null;
  }

  return (
    <>
      {adultAge && (
        <div className={styles.infoText}>
          <Trans data={dictionary.infoText}
                 values={{ count: adultAge }}
                 tOptions={{ age: adultAge }}
                 components={{
                   ref: (
                     <a className={styles.offerLink}
                        onClick={onModalOpen}
                        data-test="offer-link" />
                   ),
                 }} />
        </div>
      )}
      {modalVisibility && (
        <OfferModal isOpen={modalVisibility}
                    onClose={onModalClose} />
      )}

    </>
  );
};
